import React from 'react';
import {Lines} from '../../../clean-components/lines/lines';
import {Page} from '../../../clean-components/page/page';

export function LinesMobile() {
    return <Page title="translation:misc_transport_lines_title">
        <Lines/>
    </Page>;
}
